const wholeDollarFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const centsDollarFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

export function formatDollars(value: number): string {
  const rounded = Math.round(value * 100) / 100;
  return rounded % 1 === 0 ? wholeDollarFormatter.format(rounded) : centsDollarFormatter.format(rounded);
}

export function formatLargeDollars(value: number) {
  if (value >= 10e5) {
    return `${formatDollars(value / 10e5)}M`;
  }
  if (value >= 10e4) {
    return `${formatDollars(value / 10e2)}K`;
  }
  return `${formatDollars(value)}`;
}

export function formatPricePlusMinus(price: number, omitPlus = false) {
  let prefix = "";
  if (!omitPlus) {
    prefix = price < 0 ? "-" : "+";
  } else {
    prefix = price < 0 ? "-" : "";
  }

  return `${prefix}${formatDollars(Math.abs(price))}`;
}

/**
 * Format a number as USD currency without decimal places.
 * Useful for displaying whole dollar amounts like property prices.
 */
export function formatDollarsWholeNumber(value: number): string {
  return wholeDollarFormatter.format(value);
}
